import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class UserMatchLineup extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "matchId", Model.attribute('matchId'));
    _defineProperty(this, "userId", Model.attribute('userId'));
    _defineProperty(this, "formation", Model.attribute('formation'));
    _defineProperty(this, "kit", Model.attribute('kit'));
    _defineProperty(this, "playersRaw", Model.attribute('playersRaw'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "match", Model.hasOne('match'));
  }
  apiEndpoint() {
    return '/nagusi/match-ratings/user-match-lineups' + (this.exists ? '/' + this.data.id : '');
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/UserMatchLineup', UserMatchLineup);